import styled from 'styled-components';
import { ToggleButton } from '@simplywallst/ui-core';

export const StyledToggleButton = styled(ToggleButton)`
  padding: 0 ${({ theme }) => theme.x0_5}px;

  > svg {
    opacity: 1;
  }
`;
